// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"263":"f1921aae","594":"e9cd6b34"}[chunkId] + ".js";
};